import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePreview = () => {
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === 'true';

  const previewData = useMemo(() => {
    if (!isPreview) return null;
    try {
      const raw = localStorage.getItem('PESA_PREVIEW_DATA');
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }, [isPreview]);

  return { isPreview, previewData };
};